// extracted by mini-css-extract-plugin
export default {"conteiner":"App_conteiner__1Esgu"};